import { onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { RouteNames } from '@/data/routes';
import { auth0, retrieveAccessToken } from '@/utils/auth0';

const AUTH_TOKEN_EXPIRY_CHECK_IN_MIN = 5;

export function useAuthTokenExpiry() {
  const router = useRouter();

  async function checkTokenExpiry() {
    if (!auth0.isAuthenticated?.value) return;
    try {
      await retrieveAccessToken({
        cacheMode: 'off',
      });
    } catch (_error) {
      try {
        await router.push({ name: RouteNames.AUTH.LOGOUT });
      } catch (navError) {
        // eslint-disable-next-line no-console
        console.warn('Navigation error during logout.', navError);
      }
    }
  }

  const timeToWaitInMs = AUTH_TOKEN_EXPIRY_CHECK_IN_MIN * 1000 * 60;
  const intervalId = setInterval(() => {
    checkTokenExpiry().catch((_error) => {
      // eslint-disable-next-line no-console
      console.warn('Error in token expiry check interval.');
    });
  }, timeToWaitInMs);

  onUnmounted(() => clearInterval(intervalId));

  return { checkTokenExpiry };
}
